$(function () {
	let cardId = window.location.hash
	if (cardId) {
        const card = document.querySelector(cardId)
        if (card) {
            $(cardId).collapse('show')
            $('html, body').animate({
                scrollTop: $(cardId).offset().top - 370
            }, 500);
        }
	}
}());


// WEBPACK FOOTER //
// ./config/module-publish/resources-cvrez/js/third/accordion.js